<template>
  <div class="ouhuang-page pk-account-panel">
    <section class="ouhuang-hero">
      <div>
        <span>今日欧皇</span>
        <h1>欧皇争霸</h1>
        <p>按当天单件最高开箱价值排名，每小时更新，每日结算。</p>
      </div>
      <div class="hero-stat">
        <b>{{ ranking.length }}</b>
        <em>今日上榜玩家</em>
        <small>{{ enabled ? `距离刷新 ${refreshText}` : "榜单未开启" }}</small>
      </div>
    </section>

    <section class="rank-layout">
      <article class="podium-card">
        <div class="section-head"><span>TOP 3</span><h2>今日最佳掉落</h2></div>
        <div v-if="topThree.length" class="podium">
          <div v-for="item in topThree" :key="item.player_id" class="podium-player" :class="'rank-'+item.rank_no">
            <div class="rank-badge">{{ item.rank_no }}</div>
            <img v-if="avatar(item)" :src="avatar(item)" alt="" />
            <span v-else>{{ nameInitial(item.name) }}</span>
            <strong>{{ item.name || 'PizzaKing 玩家' }}</strong>
            <em>{{ price(item.best_price) }} <i></i></em>
            <small>{{ item.drop_count }} 次今日掉落</small>
          </div>
        </div>
        <div v-else class="empty-card">今天暂时还没有打开箱子掉落，上榜机会留给第一位玩家。</div>
      </article>

      <article class="reward-card">
        <div class="section-head"><span>奖励</span><h2>奖励档位</h2></div>
        <div v-if="rewards.length" class="reward-list">
          <div v-for="item in rewards" :key="item.id" class="reward-row">
            <b>TOP {{ item.rank_start }}<template v-if="item.rank_end != item.rank_start">-{{ item.rank_end }}</template></b>
            <img v-if="item.reward_currency === 'skin' && item.skin_image" :src="item.skin_image" :alt="item.skin_name" />
            <span>{{ rewardText(item) }}</span>
          </div>
        </div>
        <div v-else class="empty-card">当前未开启奖励档位，榜单仍会正常统计。</div>
      </article>
    </section>

    <section class="ranking-card">
      <div class="ranking-head">
        <div><span>小时排行</span><h2>完整排行榜</h2></div>
        <button :disabled="loading" @click="loadRanking">{{ loading ? "刷新中" : "刷新榜单" }}</button>
      </div>
      <div v-if="ranking.length" class="ranking-list">
        <article v-for="item in ranking" :key="item.player_id" class="ranking-row">
          <b class="rank-no">{{ item.rank_no }}</b>
          <img v-if="avatar(item)" :src="avatar(item)" alt="" />
          <span v-else class="avatar-fallback">{{ nameInitial(item.name) }}</span>
          <strong>{{ item.name || 'PizzaKing 玩家' }}</strong>
          <em>{{ item.drop_count }} 次打开箱子</em>
          <div>{{ price(item.best_price) }} <i></i></div>
        </article>
      </div>
      <div v-else class="empty-card">{{ enabled ? "本小时暂无排行榜数据。" : "榜单未开启。" }}</div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return { ranking: [], rewards: [], refreshAt: "", enabled: false, now: Date.now(), refreshTimer: null, loading: false };
  },
  computed: {
    topThree() { return this.ranking.slice(0, 3); },
    refreshText() {
      const next = new Date(String(this.refreshAt || "").replace(/-/g, "/")).getTime();
      if (!next) return "--:--";
      const seconds = Math.max(0, Math.floor((next - this.now) / 1000));
      const hours = String(Math.floor(seconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
      const remain = String(seconds % 60).padStart(2, "0");
      return `${hours}:${minutes}:${remain}`;
    },
  },
  mounted() {
    this.loadRanking();
    this.refreshTimer = window.setInterval(this.refreshRanking, 1000);
  },
  beforeDestroy() {
    window.clearInterval(this.refreshTimer);
  },
  methods: {
    refreshRanking() {
      this.now = Date.now();
      const next = new Date(String(this.refreshAt || "").replace(/-/g, "/")).getTime();
      if (next && this.now >= next && !this.loading) this.loadRanking();
    },
    loadRanking() {
      this.loading = true;
      this.$axios.post("/index/Ouhuang/ranking", this.$qs.stringify({})).then((res) => {
        if (res.data.status == 1) {
          this.ranking = res.data.data.list || [];
          this.rewards = res.data.data.rewards || [];
          this.enabled = Number(res.data.data.enabled || 0) === 1;
          this.refreshAt = res.data.data.next_refresh_at || "";
        }
      }).finally(() => { this.loading = false; });
    },
    avatar(item) { return item.img || item.image || ""; },
    nameInitial(name) { return (name || "P").slice(0, 1).toUpperCase(); },
    price(value) { return Number(value || 0).toFixed(2); },
    rewardText(item) {
      if (item.reward_currency === "key") return `${Number(item.reward_amount || 0)} 把 ${item.key_name || "专属钥匙"}`;
      if (item.reward_currency === "skin") return item.skin_name || "饰品奖励";
      return `${this.price(item.reward_amount)} ${item.reward_currency === "cheese" ? "奶酪币" : "披萨币"}`;
    },
  },
};
</script>

<style lang="less" scoped>
.ouhuang-page { min-height: calc(100vh - 198px); padding: 28px 28px 82px; color: #f5f7ff; background: radial-gradient(ellipse at 50% 0, rgba(255,137,31,.16), transparent 35%), linear-gradient(180deg,#20222f 0,#171923 100%); }
.ouhuang-hero { max-width: 1320px; min-height: 268px; margin: 0 auto 18px; padding: 38px 46px; display: flex; align-items: center; justify-content: space-between; gap: 34px; overflow: hidden; position: relative; border: 1px solid rgba(255,170,44,.26); border-radius: 10px; background: radial-gradient(circle at 78% 48%, rgba(255,160,33,.3), transparent 23%), linear-gradient(120deg,#292c3c,#1e202c); }
.ouhuang-hero::after { content:""; width: 520px; height: 160px; position: absolute; right: -68px; bottom: -100px; border: 1px solid rgba(255,205,107,.28); border-radius: 50%; box-shadow: 0 0 72px rgba(255,132,0,.2); }
.ouhuang-hero span,.section-head span,.ranking-head span { color: #ffb536; font-size: 12px; font-weight: 1000; letter-spacing: .16em; }
.ouhuang-hero h1 { margin: 10px 0; font-size: 52px; line-height: 1; font-weight: 1000; }
.ouhuang-hero p { max-width: 720px; margin: 0; color: #aeb7ca; line-height: 1.8; font-weight: 800; }
.hero-stat { min-width: 200px; padding: 22px; position: relative; z-index: 1; text-align: center; border: 1px solid rgba(255,202,105,.18); border-radius: 8px; background: rgba(14,16,24,.34); }
.hero-stat b { display: block; color: #ffe194; font-size: 46px; font-weight: 1000; }
.hero-stat em,.hero-stat small { display: block; margin-top: 5px; color: #aeb7ca; font-style: normal; font-size: 13px; font-weight: 800; }.hero-stat small { color:#ffb536; }
.rank-layout { max-width:1320px; margin:0 auto; display:grid; grid-template-columns: 1.45fr .85fr; gap:18px; }.podium-card,.reward-card,.ranking-card { padding:26px; border:1px solid #303342; border-radius:8px; background:#222431; }.section-head h2,.ranking-head h2 { margin:6px 0 0; color:#f8f9ff; font-size:25px; font-weight:1000; }.podium { min-height:238px; margin-top:24px; display:flex; align-items:flex-end; justify-content:center; gap:12px; }.podium-player { flex:1; min-height:164px; padding:18px 10px; position:relative; display:flex; flex-direction:column; align-items:center; border:1px solid rgba(255,255,255,.06); border-radius:7px; background:#2a2c3a; text-align:center; }.podium-player.rank-1 { min-height:216px; order:2; border-color:rgba(255,192,59,.44); background:radial-gradient(circle at 50% 0,rgba(255,178,37,.22),transparent 58%),#2b2d3b; }.podium-player.rank-2 { order:1; }.podium-player.rank-3 { order:3; }.rank-badge { width:28px;height:28px; position:absolute; top:-13px; display:grid;place-items:center;color:#181923;background:#c8ccd6;border-radius:50%;font-weight:1000; }.rank-1 .rank-badge { width:38px;height:38px;top:-19px;background:linear-gradient(180deg,#ffe69c,#ff9d19); }.podium-player img,.podium-player > span { width:62px;height:62px; display:grid;place-items:center; object-fit:cover; border-radius:50%; background:#3c4052; }.rank-1 img,.rank-1 > span { width:80px;height:80px; }.podium-player strong { margin-top:12px; font-size:15px; }.podium-player em { margin-top:7px;color:#ffd762;font-size:17px;font-style:normal;font-weight:1000; }.podium-player small { margin-top:6px;color:#9099ad; }.podium-player i,.ranking-row i { width:15px;height:15px;display:inline-block;vertical-align:-2px;background:url("../assets/pizzaking/pizza-token.svg") center/contain no-repeat; }.reward-list { margin-top:22px; display:grid; gap:10px; }.reward-row { min-height:54px; padding:12px; display:flex; align-items:center; justify-content:space-between; gap:10px; border:1px solid rgba(255,255,255,.055); border-radius:6px; background:#292b39; }.reward-row b { color:#ffbc3e; }.reward-row span { color:#dce2f2;font-weight:900; }.ranking-card { max-width:1320px;margin:18px auto 0; }.ranking-head { display:flex;align-items:flex-end;justify-content:space-between;gap:20px; }.ranking-head button { height:38px;padding:0 16px;color:#1a1b24;border:0;border-radius:5px;background:linear-gradient(180deg,#ffd04d,#ff8d00);font-weight:1000;cursor:pointer; }.ranking-list { margin-top:20px;display:grid;gap:8px; }.ranking-row { min-height:68px;padding:10px 14px;display:grid;grid-template-columns:42px 44px 1fr 130px 150px;gap:14px;align-items:center;border:1px solid rgba(255,255,255,.055);border-radius:6px;background:#292b39; }.rank-no { color:#aeb8cd;font-size:18px; }.ranking-row img,.avatar-fallback { width:42px;height:42px;display:grid;place-items:center;object-fit:cover;border-radius:50%;background:#3d4052;color:#fff;font-weight:1000; }.ranking-row strong { color:#f4f6ff; }.ranking-row em { color:#96a0b5;font-size:13px;font-style:normal;font-weight:800; }.ranking-row div { color:#ffd762;text-align:right;font-size:18px;font-weight:1000; }.empty-card { margin-top:22px;padding:32px 16px;color:#929caf;text-align:center;border:1px dashed rgba(255,255,255,.12);border-radius:7px;background:rgba(0,0,0,.1);font-weight:800; } @media(max-width:900px){.ouhuang-page{padding:16px 12px 60px}.ouhuang-hero,.rank-layout{display:block}.ouhuang-hero{padding:28px 22px}.hero-stat{margin-top:24px}.rank-layout .reward-card{margin-top:14px}.ranking-row{grid-template-columns:34px 40px 1fr;gap:10px}.ranking-row em{display:none}.ranking-row div{grid-column:3;text-align:left}.podium{gap:7px}.podium-player{padding:16px 4px}.podium-player strong{font-size:12px}}
.reward-row img { width:48px;height:36px;object-fit:contain;margin-left:auto; }
</style>
